module.exports = __webpack_public_path__ + "static/media/COMP-ETH.8c9e74cd.svg";